import * as types from "../../Action/actionTypes"

const initialState = {
  data: null,
  loading: false,
  error: null,
}

const verifyOtpReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.VERIFY_OTP_START:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case types.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
    case types.VERIFY_OTP_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

export default verifyOtpReducer
